module.exports = __webpack_public_path__ + "img/hero-4.0f86be20.jpeg";